import React from 'react';
import Grid from '@mui/material/Grid';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { useTranslation } from 'react-i18next';
import GroupWorkForce from './groupWorkForce';
import GroupAvailability from './groupAvailability';
import { useParams } from 'react-router-dom';
import { useUIContext } from '../../contexts/ui/ui.context';
import { get } from 'src/api/api';
import { useQuery } from 'react-query';
import Loader from 'src/shared/defaultLoader';

export default function Group() {
  let { id: groupId } = useParams();
  const { t } = useTranslation();
  const { setAppBarTitle } = useUIContext();

  const [viewType, setViewType] = React.useState('AVAILABILITY');

  const getQueryFn = async () => await get(`group/${groupId}`);
  const { isLoading } = useQuery(['group', groupId], getQueryFn, {
    onSuccess: (data) => {
      setAppBarTitle(`${t('GROUP_NAME')}: ${data.group_name}`);
    },
  });

  if (isLoading) {
    return <Loader />;
  }

  const handleChange = (event, newType) => {
    if (newType !== null) {
      setViewType(newType);
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ToggleButtonGroup color="primary" value={viewType} exclusive fullWidth onChange={handleChange}>
          <ToggleButton value="AVAILABILITY">{t('AVAILABILITY')}</ToggleButton>
          <ToggleButton value="WORKFORCE">{t('WORKFORCE')}</ToggleButton>
        </ToggleButtonGroup>
      </Grid>

      <Grid item xs={12}>
        {viewType === 'WORKFORCE' ? <GroupWorkForce noToggleButton groupId={groupId} /> : <GroupAvailability groupId={groupId} />}
      </Grid>
    </Grid>
  );
}
